import styled from 'styled-components';

export const StyledDiagnosesFormTab = styled.div`
   height: 100%;
   overflow: hidden;
`;

StyledDiagnosesFormTab.displayName = 'StyledDiagnosesFormTab';
